module.exports = __webpack_public_path__ + "static/media/Rubik-Light.2089515c.ttf";